import React, {Component} from 'react';
import TagLink from "../../Common/components/TagLink";
import PropTypes from 'prop-types';
import {categoryName, categoryUrlRoot} from "../../../utils/ArticleUtils";
import "./ArticleSubheading.scss";
import withErrorBoundary from "../../Errors/components/withErrorBoundry";

export class ArticleSubheading extends Component {
    static contextTypes = {
        metrics: PropTypes.object
    }
    
    static propTypes = {
        article: PropTypes.object,
    }

    constructor(props) {
        super(props);

        this.onCategoryClick = this.onCategoryClick.bind(this);
    }

    onCategoryClick() {
        if (!this.context.metrics || !this.context.metrics.track) {
            return;
        }

        this.context.metrics.track("linkClick", {link: '[Articles] Article Bucket Tag Click'});
    }

    render() {
        const {article} = this.props;

        const { category } = article;

        return (
          <div className="news-article-subheading">
            <div className="news-article-lastupdated">        
                <span onClick={this.onCategoryClick}>
                    <TagLink link={`/${categoryUrlRoot(category)}`}>{categoryName(category)}</TagLink>
                </span>
            </div>
          </div>
        )        
    }
}

export default withErrorBoundary(ArticleSubheading);



// WEBPACK FOOTER //
// ./modules/News/components/ArticleSubheading.js